import { render, staticRenderFns } from "./MaterialCategory.vue?vue&type=template&id=0dc9e628&scoped=true"
import script from "./MaterialCategory.vue?vue&type=script&lang=js"
export * from "./MaterialCategory.vue?vue&type=script&lang=js"
import style0 from "./MaterialCategory.vue?vue&type=style&index=0&id=0dc9e628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc9e628",
  null
  
)

export default component.exports